import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { urlLogin } from './destino-login.util';

/**
 * Guard funcional que valida que exista una sesión activa.
 * Sin token manda al login con la pantalla pedida como destino, para regresar a ella (con sus
 * filtros) al iniciar sesión.
 * @returns true si el usuario tiene sesión; si no, el árbol de URL del login
 * @author Sistema Kobra
 */
export const authGuard: CanActivateFn = (_ruta, estado): boolean | UrlTree => {
  if (localStorage.getItem('access-token')) {
    return true;
  }
  return inject(Router).parseUrl(urlLogin(estado.url));
};
